<template>
<div>
  <v-container>
    <v-form
    ref="userForm"
    lazy-validation>
        <v-row justify="space-around">
            <v-col cols="12" md="5">
                <v-text-field
                v-model.trim="user.name"
                v-bind:label="$t('name')">
                </v-text-field>
                <v-text-field
                v-model.trim="user.lastname"
                v-bind:label="$t('lastname')">
                </v-text-field>
                <v-text-field
                v-model.trim="user.username"
                v-bind:label="$t('username')"
                readonly>
                </v-text-field>
                <v-text-field
                v-model.trim="user.password"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                v-bind:label="$t('newPassword')">
                </v-text-field>
                <v-text-field
                v-model.trim="user.email"
                v-bind:label="$t('email')"
                :rules="[v => !!v || '!', v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email adresa nije validna']">
                </v-text-field>
                <v-btn 
                class="mx-2"
                :dark="hasChanged"
                :disabled="!hasChanged"
                color="#2b5d66"
                @click="save">
                {{ $t('save') }}
                </v-btn>
                <v-btn 
                class="mx-2"
                :dark="hasChanged"
                :disabled="!hasChanged"
                color="#2b5d66"
                @click="cancel">
                {{ $t('cancel') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
  </v-container>
</div>
</template>
<script>
    export default {
        name: "UserInfo",
        data() {
            return {
                showPassword: false,
                user: {
                    userId: -1,
                    username: "",
                    name: "",
                    lastname: "",
                    email: "",
                    password: ""
                }
            }
        },
        mounted() {
            this.getUserInformation();
        },
        computed: {
            hasChanged () {
                return JSON.stringify(this.user) !== JSON.stringify(this.loggedUser);
            },
            loggedUser() {
                return this.$store.getters.loggedUser;
            },
        },
        methods: {
            getUserInformation() {
                this.user = JSON.parse(JSON.stringify(this.loggedUser));
            },
            validation() {
                return this.$refs.userForm.validate();
            },
            save() {
                if(this.validation()) {
                    this.$store.dispatch('editUser', this.user)
                    .then(() => {
                        this.$root.displayNotificationMsg(this.$t('saved'), 'success');
                        this.user.password = null;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$root.displayNotificationMsg(err, 'warning')
                    })
                }
                else {
                    this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning')
                }
            },
            cancel() {
                this.user = JSON.parse(JSON.stringify(this.loggedUser));
            }
        }
    }
</script>
